import Body from "features/shared/styles/typography/Body.styled";
import { Summary } from "features/shared/styles/typography/Summary.styled";
import styled from "styled-components";

const ConsentBanner = styled.div`
  display: flex;
  gap: 0.5rem;
  background-color: ${({ theme }) => theme.colors.primary1};
  padding: 1rem 1rem 1.25rem 1rem;
  color: ${({ theme }) => theme.colors.baseWhite};
  border-radius: ${({ theme }) => theme.borderRadiusBanner};

  ${Summary}, ${Body} {
    color: ${({ theme }) => theme.colors.baseWhite};
  }

  .cta-icon {
    width: 3.5rem;
    height: 3.5rem;
  }
`;

export default ConsentBanner;
